import type { Suggestion } from '~/components/SearchSuggest';
import type { MaybeRefOrGetter, Ref, ShallowRef } from 'vue';

import { useSearchSuggestUncommittedDismiss } from './useSearchSuggestUncommittedDismiss';

/**
 * Fecha o dialog de busca aplicando a mesma regra do dropdown: descartar rascunho
 * ou re-sincronizar com o termo do pai. Use quando o rótulo vem de URL/store.
 *
 * **SRP (`SuggestDialog`):** não usa — fecha com `syncDialogOpen` / `closeDialog` simples.
 */
export interface UseSearchSuggestDialogDismissRestoreOptions {
	parentSearchTerm: MaybeRefOrGetter<string | undefined>;
	emitUpdateSearchTerm: (value: string) => void;
	searchTerm: Ref<string>;
	modelValue: Ref<Suggestion | undefined>;
	isUpdatingFromWatch: Ref<boolean>;
	hasSelectedValue: ShallowRef<boolean>;
	backupSearchTerm: Ref<string>;
	handleApplySearchTerm: () => void;
	isOpen: Ref<boolean>;
}

export function useSearchSuggestDialogDismissRestore(
	options: UseSearchSuggestDialogDismissRestoreOptions
) {
	const { applyOnCloseWithoutConfirmedSelection } =
		useSearchSuggestUncommittedDismiss({
			parentSearchTerm: options.parentSearchTerm,
			onClearParentSearchTerm: () => options.emitUpdateSearchTerm(''),
			searchTerm: options.searchTerm,
			modelValue: options.modelValue,
			isUpdatingFromWatch: options.isUpdatingFromWatch,
			hasSelectedValue: options.hasSelectedValue,
			backupSearchTerm: options.backupSearchTerm,
			handleApplySearchTerm: options.handleApplySearchTerm
		});

	const { isOpen } = options;

	function onCommandDialogOpenChange(open: boolean): void {
		if (!open) {
			applyOnCloseWithoutConfirmedSelection();
			isOpen.value = false;
		} else {
			isOpen.value = open;
		}
	}

	function closeDialog(): void {
		applyOnCloseWithoutConfirmedSelection();
		isOpen.value = false;
	}

	return {
		onCommandDialogOpenChange,
		closeDialog
	};
}
